export default __webpack_public_path__ + "static/media/star-filled.fd1eaeb0.svg";